"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationTitle = void 0;
const react_1 = __importDefault(require("react"));
const common_1 = require("../../../../../common");
const styled_components_1 = __importDefault(require("styled-components"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const account_1 = require("../../../../base/account");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const Container001Styled = styled_components_1.default.div `
	&.header {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		flex-wrap: wrap;

		${props => props.$isMobile
    ? `
				display: flex;
				flex-direction: column;
				gap: 10px;
				align-items: flex-start;
				justify-content: center;
				align-self: stretch;
				flex-shrink: 0;
				position: relative;`
    : `
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				align-self: stretch;
				flex-shrink: 0;
				position: relative;
				flex-wrap: wrap;
		`}

		.active-bar {
			display: flex;
			flex-direction: row;
			gap: 14px;
			align-items: center;
			justify-content: flex-end;
			flex-shrink: 0;
			position: relative;
			flex-wrap: wrap;
			flex: 1;
		}

		.class-reservation {
			color: var(--color-black, #101010);
			text-align: center;
			font-family: var(--h3-font-family, 'Noto Sans KR', sans-serif);

			font-weight: var(--h3-font-weight, 700);
			position: relative;
			display: flex;

			${props => props.$isMobile
    ? `font-size: var(--h3-font-size, 16px);
			line-height: 150%`
    : props.$isTablet
        ? `font-size: var(--h3-font-size, 18px);
			line-height: 150%`
        : `font-size: var(--h3-font-size, 24px);
			line-height: var(--h3-line-height, 36px);`}

			${props => props.$isTablet
    ? `
					flex: 1;
					align-items: flex-start;
			justify-content: flex-start;`
    : `
			align-items: center;
			justify-content: center;`}
		}
	}
`;
exports.ReservationTitle = react_1.default.memo(({ isPrevious, handlerFilterList, previousSearchContent, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const isTeacher = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsTeacher)(state));
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    return (react_1.default.createElement(Container001Styled, { "$isMobile": isMobile, "$isTablet": isTablet, className: "header" },
        (!isTeacher || (isTeacher && isDesktop)) && (react_1.default.createElement("div", { className: "class-reservation" }, !isTeacher
            ? t('conference.nextReseration')
            : t(`conference.${isPrevious ? 'lastClass' : 'reservation'}`))),
        react_1.default.createElement("div", { className: "active-bar", style: { gap: 14 } },
            react_1.default.createElement(common_1.SearchBar, { className: `${!isMobile ? 'search-bar-qna' : 'search-bar-mobile'}`, filterData: "title", handlerFilterList: handlerFilterList, defaultSearchContent: previousSearchContent }))));
});
